(function() {
  var productCache = {};

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) {
      return Shopify.formatMoney(cents, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
    }

    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function getProduct(handle) {
    if (!handle) {
      return Promise.resolve(null);
    }

    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js', {
        headers: {
          Accept: 'application/json'
        }
      }).then(function(response) {
        if (!response.ok) {
          throw new Error('Product not available: ' + handle);
        }

        return response.json();
      });
    }

    return productCache[handle];
  }

  function cartAddUrl() {
    var url = window.theme && theme.routes_cart_add_url ? theme.routes_cart_add_url : '/cart/add';
    return /\.js(\?|$)/.test(url) ? url : url + '.js';
  }

  function variantId(value) {
    var id = Number(value);
    return Number.isFinite(id) && id > 0 ? id : '';
  }

  function cartErrorMessage(error) {
    var message = error && error.message ? error.message : 'Could not add package to cart.';

    if (/cannot find variant/i.test(message)) {
      return message + ' Check that the tune, maps, and selected hardware variants are active, published to Online Store, and available on the previewed store.';
    }

    return message;
  }

  function shopifySizedImageUrl(url, size) {
    if (!url || url.indexOf('cdn.shopify.com') === -1) {
      return url;
    }

    return url.replace(/(\.(?:png|jpe?g|webp))(\?.*)?$/i, '_' + size + 'x$1$2');
  }

  function resolveVariant(option) {
    if (!option || !option.handle) {
      option.variant = null;
      option.price = 0;
      option.available = true;
      return Promise.resolve(option);
    }

    return getProduct(option.handle).then(function(product) {
      var variants = product && product.variants ? product.variants : [];
      var variant = variants.filter(function(item) {
        return item.sku === option.sku;
      })[0];

      if (!variant) {
        throw new Error('Variant not found for SKU ' + option.sku);
      }

      option.productTitle = product.title;
      option.variant = variant;
      option.variant.id = variantId(variant.id);
      option.price = Number(variant.price || 0);
      option.available = variant.available !== false;
      option.image = variant.featured_image && variant.featured_image.src ? variant.featured_image.src : product.featured_image || (product.images && product.images.length ? product.images[0] : '');
      return option;
    });
  }

  function resolveTuneVariant(config) {
    if (!config || !config.product || !config.product.handle) {
      return Promise.reject(new Error('Tune product handle is missing.'));
    }

    return getProduct(config.product.handle).then(function(product) {
      var variants = product && product.variants ? product.variants : [];
      var currentId = variantId(config.product.variantId);
      var variant = null;

      if (config.product.tuneSku) {
        variant = variants.filter(function(item) {
          return item.sku === config.product.tuneSku;
        })[0];
      }

      if (!variant && currentId) {
        variant = variants.filter(function(item) {
          return variantId(item.id) === currentId;
        })[0];
      }

      if (!variant) {
        variant = variants.filter(function(item) {
          return item.available !== false;
        })[0];
      }

      if (!variant) {
        throw new Error('Tune variant is not available on the Online Store.');
      }

      config.product.title = product.title || config.product.title;
      config.product.variantId = variantId(variant.id);
      config.product.price = Number(variant.price || config.product.price || 0);
      config.product.available = variant.available !== false;
      config.product.image = variant.featured_image && variant.featured_image.src ? variant.featured_image.src : product.featured_image || config.product.image || '';

      return config.product;
    });
  }

  function deviceByKey(options, key) {
    return options.devices.filter(function(item) {
      return item.key === key;
    })[0];
  }

  function includedDevices(device, options) {
    var keys = device && device.includedDeviceKeys ? device.includedDeviceKeys : [];
    return keys.map(function(key) {
      return deviceByKey(options, key);
    }).filter(Boolean);
  }

  function deviceTotalPrice(device, options) {
    var total = device && device.variant ? Number(device.price || 0) : 0;

    includedDevices(device, options).forEach(function(included) {
      if (included.variant) {
        total += Number(included.price || 0);
      }
    });

    return total;
  }

  function deviceAvailable(device, options) {
    if (!device || device.available === false) {
      return false;
    }

    return includedDevices(device, options).every(function(included) {
      return included.available !== false;
    });
  }

  function deviceMeta(device, options) {
    var meta = {
      label: device.label,
      description: '',
      priceText: '',
      imageBrief: '',
      badge: '',
      badgeTone: ''
    };

    if (device.key === 'none') {
      meta.label = 'Already own compatible bootmod3 hardware?';
      meta.description = 'Select software only. Only choose this if you already own compatible bootmod3 hardware.';
      meta.priceText = '';
      meta.imageBrief = 'Existing compatible bootmod3 hardware';
    } else if (device.key === 'wifi') {
      meta.label = 'MODE WiFi setup';
      meta.description = 'Easiest wireless setup. Works with iPhone, iPad, Android, tablets and laptops.';
      meta.priceText = '+ ' + money(deviceTotalPrice(device, options));
      meta.imageBrief = 'Phone wirelessly connecting to OBD adapter';
      meta.badge = 'Recommended';
    } else if (device.key === 'mhd_wifi') {
      var modeWifi = deviceByKey(options, 'wifi');
      var modeWifiAvailable = modeWifi && deviceAvailable(modeWifi, options);

      meta.label = 'MHD WiFi setup';
      meta.description = 'MHD wireless setup. Works with iPhone & Android.';
      meta.priceText = '+ ' + money(deviceTotalPrice(device, options));
      meta.imageBrief = 'Phone wirelessly connecting to MHD OBD adapter';
      meta.badge = modeWifiAvailable ? 'Compatible alternative' : 'Recommended alternative';
      meta.badgeTone = 'alternative';
    } else if (device.key === 'bootmod3_wifi') {
      meta.label = 'bootmod3 WiFi setup';
      meta.description = 'bootmod3 wireless setup. Works with iPhone & Android.';
      meta.priceText = '+ ' + money(deviceTotalPrice(device, options));
      meta.imageBrief = 'bootmod3 WiFi adapter';
    } else if (device.key === 'enet') {
      meta.label = 'Laptop with Ethernet (RJ45)';
      meta.description = 'For Windows/Mac laptops using a wired connection.';
      meta.priceText = '+ ' + money(deviceTotalPrice(device, options));
      meta.imageBrief = 'Laptop connected by RJ45 cable to adapter';
    } else if (device.key === 'usb_c') {
      meta.label = 'USB-C device';
      meta.description = 'For USB-C iPhones/iPads, Android phones/tablets and Windows/Mac laptops.';
      meta.priceText = '+ ' + money(deviceTotalPrice(device, options));
      meta.imageBrief = 'Phone/tablet connected by USB-C cable';
    } else if (device.key === 'lightning') {
      meta.label = 'Lightning iPhone/iPad';
      meta.description = 'For older Apple devices with the slim Lightning port.';
      meta.priceText = '+ ' + money(deviceTotalPrice(device, options));
      meta.imageBrief = 'iPhone/iPad connected by Lightning cable';
    } else {
      meta.priceText = '+ ' + money(deviceTotalPrice(device, options));
    }

    return meta;
  }

  function setFeedback(container, message, type) {
    var feedback = container.querySelector('[data-bm3-feedback]');
    if (!feedback) {
      return;
    }

    feedback.classList.remove('error', 'success');
    if (type) {
      feedback.classList.add(type);
    }
    feedback.textContent = message || '';
  }

  function selectedDevice(configurator) {
    var checked = configurator.querySelector('[name="' + configurator.id + '-device"]:checked');
    return checked ? checked.value : '';
  }

  function setButtonLabel(button, text) {
    if (!button) {
      return;
    }

    button.textContent = text;
  }

  function imageDialog(configurator) {
    return configurator.querySelector('[data-bm3-image-dialog]');
  }

  function closeImageDialog(configurator) {
    var dialog = imageDialog(configurator);
    if (!dialog || !dialog.classList.contains('is-open')) {
      return;
    }

    dialog.classList.remove('is-open');
    dialog.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bm3-modal-active');

    var image = dialog.querySelector('[data-bm3-image-dialog-img]');
    var title = dialog.querySelector('[data-bm3-image-dialog-title]');
    if (image) {
      image.removeAttribute('src');
      image.alt = '';
    }
    if (title) {
      title.textContent = '';
    }
    if (configurator._bm3LastImageTrigger && typeof configurator._bm3LastImageTrigger.focus === 'function') {
      configurator._bm3LastImageTrigger.focus();
    }
    configurator._bm3LastImageTrigger = null;
  }

  function openImageDialog(configurator, trigger) {
    var dialog = imageDialog(configurator);
    if (!dialog || !trigger || !trigger.dataset.imageSrc) {
      return;
    }

    var image = dialog.querySelector('[data-bm3-image-dialog-img]');
    var title = dialog.querySelector('[data-bm3-image-dialog-title]');
    if (!image || !title) {
      return;
    }

    var alt = trigger.dataset.imageAlt || 'Selected flashing method image';
    configurator._bm3LastImageTrigger = trigger;
    image.src = trigger.dataset.imageSrc;
    image.alt = alt;
    title.textContent = alt;
    dialog.classList.add('is-open');
    dialog.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bm3-modal-active');

    var close = dialog.querySelector('[data-bm3-image-close]');
    if (close && typeof close.focus === 'function') {
      close.focus();
    }
  }

  function bindImageDialog(configurator) {
    configurator.addEventListener('click', function(event) {
      var trigger = event.target.closest('[data-bm3-image-open]');
      if (trigger && configurator.contains(trigger)) {
        event.preventDefault();
        event.stopPropagation();
        openImageDialog(configurator, trigger);
        return;
      }

      if (event.target.matches('[data-bm3-image-dialog], [data-bm3-image-close]')) {
        event.preventDefault();
        closeImageDialog(configurator);
      }
    });

    configurator.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        closeImageDialog(configurator);
      }
    });
  }

  var UNLOCK_SERVICE_ORDER = ['instant', 'bench'];
  var UNLOCK_SERVICE_META = {
    instant: {
      label: 'MODE Instant Bench Unlock 06/2020+',
      badge: 'NEW',
      headline: 'For supported late-model MG1/MD1 DMEs. Unlock locally through MODE - no overseas DME shipping required.'
    },
    bench: {
      label: 'MODE Instant Bench Unlock Pre-06/2020',
      headline: 'For supported earlier and dealer-patch locked DMEs requiring MODE bench unlocking.'
    }
  };
  var BMW_B46_B48_BUNDLE_HANDLE = 'mode-x-bootmod3-bundle-to-suit-b48-bmw-f-series-g-series-120i-125i-220i-225i-320i-330i-420i-430i-520i-530i-x3-x4-20i-30i-tune';

  function unlockState(configurator) {
    if (!configurator._bm3UnlockState) {
      configurator._bm3UnlockState = {
        choice: ''
      };
    }

    return configurator._bm3UnlockState;
  }

  function unlockServiceByKey(options, key) {
    return (options.unlockServices || []).filter(function(service) {
      return service.key === key;
    })[0] || null;
  }

  function activeUnlockService(configurator, options) {
    var service = unlockServiceByKey(options, unlockState(configurator).choice);
    return service && service.available ? service : null;
  }

  function currentUnlock(configurator, options) {
    var service = activeUnlockService(configurator, options);
    var variant = service ? unlockVariant(service) : null;

    return variant ? { service: service, variant: variant } : null;
  }

  function unlockChoiceList(mappings, keyName, labelName) {
    var seen = {};

    return mappings.reduce(function(choices, mapping) {
      var value = String(mapping[keyName] || '');
      if (!value || seen[value]) {
        return choices;
      }

      seen[value] = true;
      choices.push({
        value: value,
        label: String(mapping[labelName] || value)
      });
      return choices;
    }, []);
  }

  function unlockMappingKey(mapping) {
    return [
      mapping.serviceKey || '',
      mapping.engineKey || '',
      mapping.methodKey || '',
      mapping.factoryOptionKey || ''
    ].join('|');
  }

  function validUnlockMapping(mapping) {
    var serviceKey = String(mapping.serviceKey || '');
    var variant = mapping.variant || {};

    if (!mapping.enabled || !UNLOCK_SERVICE_META[serviceKey] ||
        !variantId(variant.id) || variant.available === false) {
      return false;
    }

    return Boolean(mapping.methodKey) && !mapping.factoryOptionKey;
  }

  function buildUnlockServices(config, mappings) {
    var validMappings = (mappings || []).filter(validUnlockMapping).sort(function(a, b) {
      return Number(a.sortOrder || 0) - Number(b.sortOrder || 0);
    });
    var mappingCounts = {};

    validMappings.forEach(function(mapping) {
      var key = unlockMappingKey(mapping);
      mappingCounts[key] = (mappingCounts[key] || 0) + 1;
    });

    validMappings = validMappings.filter(function(mapping) {
      var key = unlockMappingKey(mapping);
      if (mappingCounts[key] > 1) {
        console.error('BootMod3 duplicate unlock mapping ignored:', key);
        return false;
      }
      return true;
    });

    return UNLOCK_SERVICE_ORDER.reduce(function(services, serviceKey) {
      var serviceMappings = validMappings.filter(function(mapping) {
        return mapping.serviceKey === serviceKey;
      });
      if (!serviceMappings.length) {
        return services;
      }

      var meta = UNLOCK_SERVICE_META[serviceKey];
      var firstVariant = serviceMappings[0].variant || {};
      var engineChoices = unlockChoiceList(serviceMappings, 'engineKey', 'engineLabel');
      var methodChoices = unlockChoiceList(serviceMappings, 'methodKey', 'methodLabel');
      var factoryOptionChoices = unlockChoiceList(serviceMappings, 'factoryOptionKey', 'factoryOptionLabel');
      var service = {
        key: serviceKey,
        label: meta.label,
        badge: meta.badge || '',
        headline: meta.headline,
        mappings: serviceMappings,
        engineChoices: engineChoices,
        methodChoices: methodChoices,
        factoryOptionChoices: factoryOptionChoices,
        image: firstVariant.image || '',
        thumbnail: firstVariant.thumbnail || firstVariant.image || '',
        available: true,
        draft: {
          engine: engineChoices.length === 1 ? engineChoices[0].value : '',
          method: '',
          remoteStart: ''
        }
      };

      if (serviceKey === 'instant' && config.product.handle === BMW_B46_B48_BUNDLE_HANDLE) {
        service.compatibilityNote = 'Instant Unlock is currently available for B48 vehicles only. Select MODE Instant Bench Unlock Pre-06/2020 for a supported B46 vehicle.';
      }

      services.push(service);
      return services;
    }, []);
  }

  function unlockVariant(service) {
    if (!service || !service.mappings || !service.draft) {
      return null;
    }

    var engine = service.draft.engine || '';
    var method = service.draft.method || '';
    var remoteStart = service.draft.remoteStart || '';

    if ((service.engineChoices.length && !engine) ||
        (service.methodChoices.length && !method) ||
        (service.factoryOptionChoices.length && !remoteStart)) {
      return null;
    }

    var mapping = service.mappings.filter(function(candidate) {
      return String(candidate.engineKey || '') === engine &&
        String(candidate.methodKey || '') === method &&
        String(candidate.factoryOptionKey || '') === remoteStart;
    })[0];

    return mapping && mapping.variant && mapping.variant.available !== false ? mapping.variant : null;
  }

  function appendUnlockFieldLabel(field, groupName, labelText, name, helpLines) {
    var labelRow = document.createElement('div');
    var label = document.createElement('span');
    var fieldId = groupName + '-' + name;

    labelRow.className = 'bm3-unlock__field-label';
    label.textContent = labelText;
    label.id = fieldId + '-label';
    label.setAttribute('for', fieldId);
    labelRow.appendChild(label);

    if (helpLines && helpLines.length) {
      var helpId = fieldId + '-help';
      var help = document.createElement('button');
      var hint = document.createElement('div');

      help.type = 'button';
      help.className = 'bm3-unlock__field-help';
      help.setAttribute('aria-expanded', 'false');
      help.setAttribute('aria-controls', helpId);
      help.setAttribute('aria-label', 'What do these options mean?');
      help.textContent = '?';
      hint.className = 'bm3-unlock__field-hint';
      hint.id = helpId;
      hint.hidden = true;

      helpLines.forEach(function(line) {
        var paragraph = document.createElement('p');
        var term = document.createElement('strong');
        term.textContent = line.term + ':';
        paragraph.appendChild(term);
        paragraph.appendChild(document.createElement('br'));
        paragraph.appendChild(document.createTextNode(line.copy));
        hint.appendChild(paragraph);
      });

      help.addEventListener('click', function() {
        var expanded = help.getAttribute('aria-expanded') === 'true';
        help.setAttribute('aria-expanded', String(!expanded));
        hint.hidden = expanded;
      });

      labelRow.appendChild(help);
      field.appendChild(labelRow);
      field.appendChild(hint);
      return fieldId;
    }

    field.appendChild(labelRow);
    return fieldId;
  }

  function appendUnlockSelect(parent, groupName, labelText, name, value, choices, helpLines) {
    var field = document.createElement('div');
    var select = document.createElement('select');
    var placeholder = document.createElement('option');

    field.className = 'bm3-unlock__field';
    select.id = appendUnlockFieldLabel(field, groupName, labelText, name, helpLines);
    select.setAttribute('aria-labelledby', select.id + '-label');
    placeholder.value = '';
    placeholder.textContent = 'Choose an option';
    placeholder.disabled = true;
    placeholder.selected = !value;
    select.dataset.bm3UnlockField = name;
    select.appendChild(placeholder);

    choices.forEach(function(choice) {
      var option = document.createElement('option');
      option.value = choice.value;
      option.textContent = choice.label;
      option.selected = value === choice.value;
      select.appendChild(option);
    });

    field.appendChild(select);
    parent.appendChild(field);
  }

  function appendUnlockChips(parent, groupName, labelText, name, value, choices, helpLines) {
    var field = document.createElement('div');
    var chips = document.createElement('div');

    field.className = 'bm3-unlock__field';
    appendUnlockFieldLabel(field, groupName, labelText, name, helpLines);
    chips.className = 'bm3-unlock__chips';
    chips.setAttribute('role', 'radiogroup');
    chips.setAttribute('aria-label', labelText);

    choices.forEach(function(choice) {
      var chip = document.createElement('div');
      var control = document.createElement('label');
      var input = document.createElement('input');
      var text = document.createElement('span');

      chip.className = 'bm3-unlock-chip';
      control.className = 'bm3-unlock-chip__control';
      input.type = 'radio';
      input.name = groupName + '-' + name;
      input.value = choice.value;
      input.dataset.bm3UnlockField = name;
      input.checked = value === choice.value;
      text.textContent = choice.label;

      control.appendChild(input);
      control.appendChild(text);
      chip.appendChild(control);

      chips.appendChild(chip);
    });

    field.appendChild(chips);
    parent.appendChild(field);
  }

  // Two-choice fields commit in a single tap as chips; longer lists stay as a select.
  function appendUnlockField(parent, groupName, labelText, name, value, choices, helpLines) {
    if (choices.length > 2) {
      appendUnlockSelect(parent, groupName, labelText, name, value, choices, helpLines);
    } else {
      appendUnlockChips(parent, groupName, labelText, name, value, choices, helpLines);
    }
  }

  function unlockFromPrice(service) {
    var prices = (service.mappings || []).filter(function(mapping) {
      return mapping.variant && mapping.variant.available !== false;
    }).map(function(mapping) {
      return Number(mapping.variant.price || 0);
    });

    return prices.length ? Math.min.apply(null, prices) : null;
  }

  function unlockMethodLabel(service) {
    var method = service && service.draft ? service.draft.method : '';
    var choice = service && (service.methodChoices || []).filter(function(item) {
      return item.value === method;
    })[0];

    return choice ? choice.label : method;
  }

  function bundleUnlockDiscount(config) {
    return Math.max(0, Number(config.bundleUnlockDiscount || 0));
  }

  function unlockCardPrice(configurator, service) {
    var variant = unlockVariant(service);
    var from = unlockFromPrice(service);

    if (unlockState(configurator).choice === service.key) {
      return variant ? '+' + money(variant.price) : (from === null ? '' : 'From ' + money(from));
    }

    return from === null ? '' : 'From ' + money(from);
  }

  function renderUnlockCardPrice(element, configurator, config, service) {
    var variant = unlockVariant(service);
    var discount = bundleUnlockDiscount(config);

    element.innerHTML = '';
    if (unlockState(configurator).choice === service.key && variant && discount > 0) {
      var original = document.createElement('s');
      var discounted = document.createElement('span');
      original.textContent = money(variant.price);
      discounted.textContent = money(Math.max(0, Number(variant.price || 0) - discount));
      element.appendChild(original);
      element.appendChild(document.createTextNode(' '));
      element.appendChild(discounted);
      return;
    }

    element.textContent = unlockCardPrice(configurator, service);
  }

  function setUnlockStatus(configurator, options) {
    var status = configurator.querySelector('[data-bm3-unlock-status]');
    if (!status) {
      return;
    }

    var service = activeUnlockService(configurator, options);

    if (service) {
      var variant = unlockVariant(service);
      status.textContent = variant ?
        service.label + ' added to your package.' :
        'Choose the options above to add ' + service.label + ' to your package.';
    } else {
      status.textContent = '';
    }
  }

  function unlockHeaderSummary(configurator, config, options) {
    var service = activeUnlockService(configurator, options);
    if (!service) {
      return '';
    }

    var variant = unlockVariant(service);
    if (!variant) {
      return service.label + ' selected - finish options';
    }

    var addedPrice = Math.max(0, Number(variant.price || 0) - bundleUnlockDiscount(config));
    return service.label + ' added - ' + money(addedPrice);
  }

  function updateUnlockHeader(configurator, config, options) {
    var toggle = configurator.querySelector('[data-bm3-unlock-toggle]');
    var view = configurator.querySelector('[data-bm3-unlock-view]');
    var selection = configurator.querySelector('[data-bm3-unlock-selection]');
    if (!toggle) {
      return;
    }

    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    if (view) {
      view.textContent = expanded ? 'Hide unlock options' : 'View unlock options';
    }

    if (selection) {
      var summary = expanded ? '' : unlockHeaderSummary(configurator, config, options);
      selection.textContent = summary;
      selection.toggleAttribute('hidden', !summary);
    }
  }

  function setUnlockExpanded(configurator, expanded, config, options) {
    var content = configurator.querySelector('[data-bm3-unlock-content]');
    var toggle = configurator.querySelector('[data-bm3-unlock-toggle]');
    if (!content || !toggle) {
      return;
    }

    toggle.setAttribute('aria-expanded', String(expanded));
    content.toggleAttribute('hidden', !expanded);
    updateUnlockHeader(configurator, config, options);
  }

  function keepUnlockOptionsAboveBuybar(configurator) {
    if (window.innerWidth > 759) {
      return;
    }

    window.requestAnimationFrame(function() {
      var content = configurator.querySelector('[data-bm3-unlock-content]');
      var buybar = configurator.querySelector('[data-bm3-buybar]');
      if (!content || content.hidden || !buybar) {
        return;
      }

      var contentRect = content.getBoundingClientRect();
      var buybarRect = buybar.getBoundingClientRect();
      var buybarIsVisible = buybarRect.bottom > 0 && buybarRect.top < window.innerHeight;
      var visibleContentHeight = Math.min(220, content.scrollHeight);
      var overlap = contentRect.top + visibleContentHeight - (buybarRect.top - 12);
      if (!buybarIsVisible || overlap <= 0) {
        return;
      }

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollBy({
        top: overlap,
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    });
  }

  function bindUnlockToggle(configurator, config, options) {
    var toggle = configurator.querySelector('[data-bm3-unlock-toggle]');
    if (!toggle) {
      return;
    }

    toggle.addEventListener('click', function() {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      setUnlockExpanded(configurator, !expanded, config, options);
      if (!expanded) {
        keepUnlockOptionsAboveBuybar(configurator);
      }
    });
  }

  function unlockImageSource(service) {
    return service ? service.image || '' : '';
  }

  // The services share one radio group. Tapping the current choice again clears it,
  // which is the explicit no-unlock state.
  function unlockChoices(options) {
    var choices = (options.unlockServices || []).filter(function(service) {
      return service.available;
    }).map(function(service) {
      return {
        key: service.key,
        service: service,
        title: service.label,
        badge: service.badge,
        description: service.headline,
        image: unlockImageSource(service),
        thumbnail: service.thumbnail,
        fallback: 'MODE'
      };
    });

    return choices;
  }

  function renderUnlockPanel(configuration, configurator, service, groupName) {
    var panel = document.createElement('div');
    var panelHead = document.createElement('div');
    var panelTitle = document.createElement('strong');
    var fields = document.createElement('div');

    panel.className = 'bm3-unlock-service__panel';
    panelHead.className = 'bm3-unlock-service__panel-head';
    panelTitle.textContent = service.label;
    panelHead.appendChild(panelTitle);
    panel.appendChild(panelHead);

    fields.className = 'bm3-unlock-service__fields';

    if (service.compatibilityNote) {
      var compatibility = document.createElement('p');
      compatibility.className = 'bm3-unlock-service__compatibility';
      compatibility.textContent = service.compatibilityNote;
      fields.appendChild(compatibility);
    }

    if (service.engineChoices.length > 1) {
      appendUnlockField(fields, groupName, 'Engine type', 'engine', service.draft.engine, service.engineChoices);
    }

    if (service.methodChoices.length) {
      appendUnlockField(fields, groupName, 'Select your preferred unlock service method', 'method', service.draft.method, service.methodChoices, [
        { term: 'Unlock at MODE Brisbane', copy: 'Have your DME/ECU unlocked directly by our MODE Brisbane team.' },
        { term: 'Unlock at a Local MODE Dealer', copy: 'Have your DME/ECU unlocked through an authorised MODE Dealer. We have dealer coverage across major regions of Australia and will coordinate the nearest suitable location after purchase.' }
      ]);
    } else if (service.factoryOptionChoices.length) {
      appendUnlockField(fields, groupName, 'Which option did your vehicle come with from factory?', 'remoteStart', service.draft.remoteStart, service.factoryOptionChoices);
    }

    panel.appendChild(fields);
    configuration.appendChild(panel);
  }

  function renderUnlockServices(configurator, config, options) {
    var container = configurator.querySelector('[data-bm3-unlock-services]');
    var configuration = configurator.querySelector('[data-bm3-unlock-configuration]');
    var state = unlockState(configurator);
    if (!container || !configuration) {
      return;
    }

    container.innerHTML = '';
    configuration.innerHTML = '';
    var groupName = configurator.id + '-unlock';

    unlockChoices(options).forEach(function(choice) {
      var card = document.createElement('label');
      var input = document.createElement('input');
      var dot = document.createElement('span');
      var media = document.createElement('span');
      var title = document.createElement('strong');
      var description = document.createElement('small');
      var price = document.createElement('span');

      card.className = 'bm3-method-card bm3-unlock-card';
      input.type = 'radio';
      input.name = groupName;
      input.value = choice.key;
      input.dataset.bm3UnlockOption = choice.key;
      input.checked = state.choice === choice.key;
      dot.className = 'bm3-select-dot';
      media.className = 'bm3-method-visual bm3-unlock-card__visual';
      var image = document.createElement('img');
      image.src = choice.thumbnail || choice.image;
      image.alt = choice.title;
      image.decoding = 'async';
      image.loading = 'eager';
      image.onerror = function() {
        if (choice.image && image.src !== choice.image) {
          image.src = choice.image;
        }
      };
      media.appendChild(image);

      title.textContent = choice.title;
      if (choice.badge) {
        var badge = document.createElement('span');
        badge.className = 'bm3-method-badge bm3-unlock-card__badge';
        badge.textContent = choice.badge;
        card.appendChild(badge);
      }
      description.textContent = choice.description;
      price.className = 'bm3-method-price';
      price.dataset.bm3UnlockPrice = choice.key;
      renderUnlockCardPrice(price, configurator, config, choice.service);

      card.appendChild(input);
      card.appendChild(dot);
      card.appendChild(media);
      card.appendChild(title);
      if (choice.description) {
        card.appendChild(description);
      }
      card.appendChild(price);

      if (choice.image) {
        var zoom = document.createElement('button');
        zoom.type = 'button';
        zoom.className = 'bm3-method-zoom';
        zoom.dataset.bm3ImageOpen = '';
        zoom.dataset.imageSrc = choice.image;
        zoom.dataset.imageAlt = choice.title;
        zoom.setAttribute('aria-label', 'View larger image for ' + choice.title);
        zoom.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path d="M10.5 4a6.5 6.5 0 0 1 5.18 10.43l4.44 4.45-1.24 1.24-4.45-4.44A6.5 6.5 0 1 1 10.5 4Zm0 1.75a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5Zm.75 2v2h2v1.5h-2v2h-1.5v-2h-2v-1.5h2v-2h1.5Z" fill="currentColor"/></svg>';
        card.appendChild(zoom);
      }

      container.appendChild(card);
    });

    var activeService = activeUnlockService(configurator, options);

    if (activeService) {
      renderUnlockPanel(configuration, configurator, activeService, groupName);
    }

    updateUnlockHeader(configurator, config, options);
  }

  function syncUnlockServices(configurator, config, options) {
    var configuration = configurator.querySelector('[data-bm3-unlock-configuration]');
    var groupName = configurator.id + '-unlock';

    if (!configuration) {
      return;
    }

    configurator.querySelectorAll('[data-bm3-unlock-option]').forEach(function(input) {
      input.checked = unlockState(configurator).choice === input.dataset.bm3UnlockOption;
    });

    configurator.querySelectorAll('[data-bm3-unlock-price]').forEach(function(price) {
      var service = unlockServiceByKey(options, price.dataset.bm3UnlockPrice);
      if (service) {
        renderUnlockCardPrice(price, configurator, config, service);
      }
    });

    configuration.innerHTML = '';
    var activeService = activeUnlockService(configurator, options);
    if (activeService) {
      renderUnlockPanel(configuration, configurator, activeService, groupName);
    }
    updateUnlockHeader(configurator, config, options);
  }

  // Option changes only repaint the price and totals - re-rendering the whole
  // panel would tear out the field the customer is arrow-keying through.
  function refreshUnlockPricing(configurator, config, options) {
    var service = activeUnlockService(configurator, options);
    var price = service && configurator.querySelector('[data-bm3-unlock-price="' + service.key + '"]');

    if (price) {
      renderUnlockCardPrice(price, configurator, config, service);
    }

    updateSummary(configurator, config, options);
    setUnlockStatus(configurator, options);
    updateUnlockHeader(configurator, config, options);
  }

  function bindUnlockServices(configurator, config, options) {
    var content = configurator.querySelector('[data-bm3-unlock-content]');
    if (!content) {
      return;
    }

    function clearUnlockChoice(input) {
      unlockState(configurator).choice = '';
      updateSummary(configurator, config, options);
      setUnlockStatus(configurator, options);
      updateUnlockHeader(configurator, config, options);

      if (configurator._bm3UnlockClearFrame) {
        window.cancelAnimationFrame(configurator._bm3UnlockClearFrame);
      }

      // A label click can restore its radio after the click listener runs.
      // Reconcile on the next frame so the visible control matches our state.
      configurator._bm3UnlockClearFrame = window.requestAnimationFrame(function() {
        configurator._bm3UnlockClearFrame = null;
        syncUnlockServices(configurator, config, options);
        if (input && typeof input.focus === 'function') {
          try {
            input.focus({ preventScroll: true });
          } catch (error) {
            input.focus();
          }
        }
      });
    }

    configurator.addEventListener('click', function(event) {
      if (event.target.closest('[data-bm3-image-open]')) {
        return;
      }

      var card = event.target.closest('.bm3-unlock-card');
      var input = card && card.querySelector('[data-bm3-unlock-option]');
      var state = unlockState(configurator);

      if (!input || state.choice !== input.dataset.bm3UnlockOption) {
        return;
      }

      event.preventDefault();
      clearUnlockChoice(input);
    });

    configurator.addEventListener('keydown', function(event) {
      var input = event.target.closest('[data-bm3-unlock-option]');

      if ((event.key !== ' ' && event.key !== 'Spacebar') ||
          !input || unlockState(configurator).choice !== input.dataset.bm3UnlockOption) {
        return;
      }

      event.preventDefault();
      clearUnlockChoice(input);
    });

    configurator.addEventListener('change', function(event) {
      var state = unlockState(configurator);

      if (event.target.matches('[data-bm3-unlock-option]')) {
        state.choice = event.target.dataset.bm3UnlockOption;
        syncUnlockServices(configurator, config, options);
        updateSummary(configurator, config, options);
        setUnlockStatus(configurator, options);
        updateUnlockHeader(configurator, config, options);
      } else if (event.target.matches('[data-bm3-unlock-field]')) {
        var service = activeUnlockService(configurator, options);
        if (service) {
          service.draft[event.target.dataset.bm3UnlockField] = event.target.value;
          refreshUnlockPricing(configurator, config, options);
        }
      }
    });
  }

  function bindChatHelp(configurator) {
    configurator.addEventListener('click', function(event) {
      var trigger = event.target.closest('[data-bm3-chat-open]');
      if (!trigger || !configurator.contains(trigger)) {
        return;
      }

      event.preventDefault();
      var bubble = document.getElementById('modeChatBubble');
      if (bubble && typeof bubble.click === 'function') {
        bubble.click();
      }
    });
  }

  function bindBootmod3PageUi(configurator) {
    document.body.classList.add('bootmod3-product');
    var pageUi = window._bm3PageUi = window._bm3PageUi || {};
    pageUi.buybar = configurator.querySelector('[data-bm3-buybar]');

    if (!pageUi.updateChatPosition) {
      pageUi.updateChatPosition = function() {
        pageUi.scheduledFrame = null;
        var buybar = pageUi.buybar;
        var bubble = document.getElementById('modeChatBubble');
        if (!bubble || !buybar) {
          return;
        }

        var baseOffset = window.innerWidth <= 480 ? 16 : 24;
        var gap = 12;
        var buybarRect = buybar.getBoundingClientRect();
        var bubbleWidth = bubble.offsetWidth || 60;
        var bubbleLeft = window.innerWidth - baseOffset - bubbleWidth;
        var horizontallyOverlaps = bubbleLeft < buybarRect.right &&
          bubbleLeft + bubbleWidth > buybarRect.left;
        var buybarIsVisible = buybarRect.bottom > 0 && buybarRect.top < window.innerHeight;
        var bottom = baseOffset;

        if (horizontallyOverlaps && buybarIsVisible) {
          bottom = Math.max(baseOffset, window.innerHeight - buybarRect.top + gap);
        }

        document.body.style.setProperty('--bm3-chat-bottom', bottom + 'px');
      };

      pageUi.scheduleChatPosition = function() {
        if (pageUi.scheduledFrame) {
          return;
        }
        pageUi.scheduledFrame = window.requestAnimationFrame(pageUi.updateChatPosition);
      };

      window.addEventListener('scroll', pageUi.scheduleChatPosition, { passive: true });
      window.addEventListener('resize', pageUi.scheduleChatPosition, { passive: true });
      window.addEventListener('orientationchange', pageUi.scheduleChatPosition, { passive: true });
    }

    if (pageUi.resizeObserver) {
      pageUi.resizeObserver.disconnect();
    }
    if (window.ResizeObserver && pageUi.buybar) {
      pageUi.resizeObserver = new ResizeObserver(pageUi.scheduleChatPosition);
      pageUi.resizeObserver.observe(pageUi.buybar);
    }

    pageUi.scheduleChatPosition();
  }

  function loadUnlockServices(configurator, config, options) {
    var wrap = configurator.querySelector('[data-bm3-unlock-wrap]');
    options.unlockServices = buildUnlockServices(config, options.unlockMappings);

    if (!options.unlockServices.length || !wrap) {
      return;
    }

    wrap.removeAttribute('hidden');
    renderUnlockServices(configurator, config, options);
  }

  function buildSummary(configurator, config, options) {
    var total = Number(config.product.price || 0);

    if (configurator.querySelector('[data-bm3-maps]').checked && options.maps && options.maps.variant) {
      total += options.maps.price;
    }

    var deviceKey = selectedDevice(configurator);
    var device = deviceByKey(options, deviceKey);

    if (device) {
      total += deviceTotalPrice(device, options);
    }

    var selectedUnlock = currentUnlock(configurator, options);
    if (selectedUnlock) {
      total += Math.max(0, Number(selectedUnlock.variant.price || 0) - bundleUnlockDiscount(config));
    }

    return {
      total: total
    };
  }

  function updateSummary(configurator, config, options) {
    var summary = buildSummary(configurator, config, options);
    var total = configurator.querySelector('[data-bm3-total]');
    var progress = configurator.querySelector('[data-bm3-progress]');

    if (total) {
      total.textContent = money(summary.total);
    }

    if (progress) {
      var vin = configurator.querySelector('[data-bm3-vin]');
      if (!vin || !vin.value.trim()) {
        progress.textContent = 'Enter your VIN';
      } else if (!selectedDevice(configurator)) {
        progress.textContent = 'Choose your flashing hardware';
      } else if (activeUnlockService(configurator, options) && !currentUnlock(configurator, options)) {
        progress.textContent = 'Finish your unlock options';
      } else {
        progress.textContent = 'Ready to add to cart';
      }
    }

    var button = configurator.querySelector('[data-bm3-add]');
    if (button && !button.disabled) {
      setButtonLabel(button, button.dataset.idleLabel || 'Add to Cart');
    }
  }

  function bindBuybarRelease(configurator) {
    var buybar = configurator.querySelector('[data-bm3-buybar]');
    var release = configurator.querySelector('[data-bm3-buybar-release]');

    if (!buybar || !release || !window.IntersectionObserver) {
      return;
    }

    var observer = null;
    var resizeFrame = null;

    function observeRelease() {
      var bottomOffset = Math.max(0, parseFloat(window.getComputedStyle(buybar).bottom) || 0);

      if (observer) {
        observer.disconnect();
      }

      observer = new IntersectionObserver(function(entries) {
        var entry = entries[0];
        var releaseLine = window.innerHeight - bottomOffset;
        var hasReachedRelease = entry.isIntersecting || entry.boundingClientRect.top < releaseLine;
        buybar.classList.toggle('is-released', hasReachedRelease);
      }, {
        rootMargin: '0px 0px -' + bottomOffset + 'px 0px',
        threshold: 0
      });
      observer.observe(release);
    }

    function scheduleReleaseObserver() {
      if (resizeFrame) {
        window.cancelAnimationFrame(resizeFrame);
      }
      resizeFrame = window.requestAnimationFrame(function() {
        resizeFrame = null;
        observeRelease();
      });
    }

    observeRelease();
    window.addEventListener('resize', scheduleReleaseObserver, { passive: true });
    window.addEventListener('orientationchange', scheduleReleaseObserver, { passive: true });
  }

  function renderDeviceOptions(configurator, config, options) {
    var container = configurator.querySelector('[data-bm3-devices]');
    var fallbackContainer = configurator.querySelector('[data-bm3-existing-device]');
    if (!container) {
      return;
    }

    var groupName = configurator.id + '-device';
    container.innerHTML = '';
    if (fallbackContainer) {
      fallbackContainer.innerHTML = '';
    }

    options.devices.forEach(function(device) {
      var label = document.createElement('label');
      var input = document.createElement('input');
      var dot = document.createElement('span');
      var media = document.createElement('span');
      var badge = document.createElement('span');
      var title = document.createElement('strong');
      var description = document.createElement('small');
      var price = document.createElement('span');
      var meta = deviceMeta(device, options);
      var available = deviceAvailable(device, options);
      var imageSource = device.visualImage || device.image;

      input.type = 'radio';
      input.name = groupName;
      input.value = device.key;
      dot.className = 'bm3-select-dot';

      if (!available) {
        input.disabled = true;
      }

      if (device.key === 'none') {
        if (!fallbackContainer) {
          return;
        }

        var copy = document.createElement('span');
        var eyebrow = document.createElement('span');

        label.className = 'bm3-method-fallback';
        copy.className = 'bm3-method-fallback__copy';
        eyebrow.className = 'bm3-method-fallback__eyebrow';
        eyebrow.textContent = 'Existing hardware only';
        title.textContent = meta.label;
        description.textContent = !available ? 'Unavailable' : meta.description;
        price.className = 'bm3-method-price';
        price.textContent = !available ? '' : meta.priceText;

        copy.appendChild(eyebrow);
        copy.appendChild(title);
        copy.appendChild(description);
        label.appendChild(input);
        label.appendChild(dot);
        label.appendChild(copy);
        label.appendChild(price);
        fallbackContainer.appendChild(label);
        return;
      }

      label.className = 'bm3-method-card';
      media.className = 'bm3-method-visual';
      media.setAttribute('aria-label', meta.imageBrief ? 'Image placeholder: ' + meta.imageBrief : 'Image placeholder');
      media.setAttribute('role', 'img');
      if (imageSource) {
        var image = document.createElement('img');
        image.src = shopifySizedImageUrl(imageSource, 520);
        image.alt = meta.imageBrief || meta.label;
        image.decoding = 'async';
        image.loading = 'eager';
        image.onerror = function() {
          if (image.src !== imageSource) {
            image.src = imageSource;
          }
        };
        media.removeAttribute('aria-label');
        media.removeAttribute('role');
        media.appendChild(image);
      }
      title.textContent = meta.label;
      description.textContent = !available ? 'Unavailable' : meta.description;
      price.className = 'bm3-method-price';
      price.textContent = !available ? '' : meta.priceText;
      label.appendChild(input);
      label.appendChild(dot);
      label.appendChild(media);
      if (meta.badge && available) {
        badge.className = 'bm3-method-badge' + (meta.badgeTone ? ' bm3-method-badge--' + meta.badgeTone : '');
        badge.textContent = meta.badge;
        label.appendChild(badge);
      }
      label.appendChild(title);
      label.appendChild(description);
      label.appendChild(price);

      if (imageSource) {
        var zoom = document.createElement('button');
        zoom.type = 'button';
        zoom.className = 'bm3-method-zoom';
        zoom.dataset.bm3ImageOpen = '';
        zoom.dataset.imageSrc = imageSource;
        zoom.dataset.imageAlt = meta.imageBrief || meta.label;
        zoom.setAttribute('aria-label', 'View larger image for ' + meta.label);
        zoom.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path d="M10.5 4a6.5 6.5 0 0 1 5.18 10.43l4.44 4.45-1.24 1.24-4.45-4.44A6.5 6.5 0 1 1 10.5 4Zm0 1.75a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5Zm.75 2v2h2v1.5h-2v2h-1.5v-2h-2v-1.5h2v-2h1.5Z" fill="currentColor"/></svg>';
        label.appendChild(zoom);
      }

      container.appendChild(label);
    });
  }

  function refreshCart() {
    if (typeof window.CartDrop === 'function') {
      window.CartDrop(false);
    }

    if (window.theme && theme.cart && typeof window.CartReload === 'function') {
      setTimeout(function() {
        fetch(theme.routes_cart_url)
          .then(function(response) {
            return response.text();
          })
          .then(function(html) {
            window.CartReload(html);
          })
          .catch(function(error) {
            console.error('BootMod3 cart refresh failed:', error);
          });
      }, 500);
    }
  }

  function addToCart(configurator, config, options) {
    var button = configurator.querySelector('[data-bm3-add]');
    var vinInput = configurator.querySelector('[data-bm3-vin]');
    var vin = vinInput ? vinInput.value.trim().toUpperCase() : '';

    if (!vin) {
      setFeedback(configurator, 'Enter your VIN before adding this tune to cart.', 'error');
      if (vinInput) {
        vinInput.focus();
      }
      return;
    }

    var deviceKey = selectedDevice(configurator);

    if (!deviceKey) {
      setFeedback(configurator, 'Choose a flashing method before adding this package to cart.', 'error');
      var firstDevice = configurator.querySelector('[name="' + configurator.id + '-device"]');
      if (firstDevice) {
        firstDevice.focus();
      }
      return;
    }

    if (!config.product.available || !variantId(config.product.variantId)) {
      setFeedback(configurator, 'This tune variant is not addable yet. Check that the tune product is active and published to Online Store.', 'error');
      return;
    }

    // Step 4 commits as you pick, so a part-answered service would otherwise drop out
    // of the cart silently.
    var selectedUnlock = currentUnlock(configurator, options);

    if (activeUnlockService(configurator, options) && !selectedUnlock) {
      setFeedback(configurator, 'Finish choosing your unlock options, or tap the selected unlock again to remove it.', 'error');
      setUnlockExpanded(configurator, true, config, options);
      var unfinishedField = configurator.querySelector('[data-bm3-unlock-field]');
      if (unfinishedField) {
        unfinishedField.focus();
      }
      return;
    }

    var bundleId = 'bm3-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
    var parentProperties = {
      VIN: vin,
      _bundle_id: bundleId,
      _bundle_parent: 'true',
      _bootmod3_platform: config.product.platform || ''
    };
    var items = [
      {
        id: variantId(config.product.variantId),
        quantity: 1,
        properties: parentProperties
      }
    ];

    if (configurator.querySelector('[data-bm3-maps]').checked) {
      if (!options.maps || !options.maps.available || !options.maps.variant || !variantId(options.maps.variant.id)) {
        setFeedback(configurator, 'Selected maps are not addable. Check the maps product is active, published to Online Store, and has the configured SKU.', 'error');
        return;
      }

      items.push({
        id: variantId(options.maps.variant.id),
        quantity: 1,
        properties: {
          _bundle_id: bundleId,
          _bundle_parent: 'false',
          _related_tune_platform: config.product.platform || ''
        }
      });
    }

    var device = deviceByKey(options, deviceKey);

    if (!device) {
      setFeedback(configurator, 'Choose a valid flashing method before adding this package to cart.', 'error');
      return;
    }

    if (!deviceAvailable(device, options)) {
      setFeedback(configurator, 'Selected flashing method is unavailable. Choose another option.', 'error');
      return;
    }

    if (device.variant) {
      items.push({
        id: variantId(device.variant.id),
        quantity: 1,
        properties: {
          _bundle_id: bundleId,
          _bundle_parent: 'false',
          _related_tune_platform: config.product.platform || ''
        }
      });
    }

    includedDevices(device, options).forEach(function(includedDevice) {
      if (includedDevice.variant) {
        items.push({
          id: variantId(includedDevice.variant.id),
          quantity: 1,
          properties: {
            _bundle_id: bundleId,
            _bundle_parent: 'false',
            _related_tune_platform: config.product.platform || ''
          }
        });
      }
    });

    if (selectedUnlock) {
      if (!variantId(selectedUnlock.variant.id)) {
        setFeedback(configurator, 'The selected unlock service is no longer available. Choose another service, or tap the selected unlock again to remove it.', 'error');
        return;
      }
      items.push({
        id: variantId(selectedUnlock.variant.id),
        quantity: 1,
        properties: {
          VIN: vin,
          _bundle_id: bundleId,
          _bundle_parent: 'false',
          _related_tune_platform: config.product.platform || '',
          _unlock_service: selectedUnlock.service.label,
          _unlock_method: unlockMethodLabel(selectedUnlock.service),
          _unlock_variant: selectedUnlock.variant.title
        }
      });
    }

    button.disabled = true;
    button.textContent = 'Adding...';
    setFeedback(configurator, '', '');

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items
      })
    }).then(function(response) {
      return response.json().then(function(json) {
        if (!response.ok || json.status) {
          throw new Error(json.description || json.message || 'Could not add package to cart.');
        }

        return json;
      });
    }).then(function() {
      setFeedback(configurator, 'Configured package added to cart.', 'success');
      refreshCart();
    }).catch(function(error) {
      console.error('BootMod3 add-to-cart failed:', error, items);
      setFeedback(configurator, cartErrorMessage(error), 'error');
    }).finally(function() {
      button.disabled = false;
      updateSummary(configurator, config, options);
    });
  }

  function initConfigurator(configurator, index) {
    if (configurator.dataset.bm3Initialized === 'true') {
      return;
    }
    configurator.dataset.bm3Initialized = 'true';

    var configScript = configurator.querySelector('[data-bootmod3-config]');
    var config = configScript ? JSON.parse(configScript.textContent) : null;

    if (!config || !config.product || !config.product.variantId) {
      setFeedback(configurator, 'BootMod3 configuration is missing for this product.', 'error');
      return;
    }

    configurator.id = configurator.id || 'bootmod3-configurator-' + index;

    var options = {
      maps: Object.assign({}, config.maps),
      devices: config.devices.map(function(device) {
        return Object.assign({}, device);
      }),
      unlockMappings: (config.unlockMappings || []).map(function(mapping) {
        return Object.assign({}, mapping, {
          variant: Object.assign({}, mapping.variant)
        });
      })
    };

    var mapsPrice = configurator.querySelector('[data-bm3-maps-price]');
    var mapsMedia = configurator.querySelector('[data-bm3-maps-media]');

    bindImageDialog(configurator);
    bindUnlockToggle(configurator, config, options);
    bindUnlockServices(configurator, config, options);
    bindChatHelp(configurator);
    bindBuybarRelease(configurator);
    bindBootmod3PageUi(configurator);
    loadUnlockServices(configurator, config, options);

    resolveTuneVariant(config).then(function() {
      updateSummary(configurator, config, options);
    }).catch(function(error) {
      config.product.available = false;
      setFeedback(configurator, error.message + ' Check that the tune product is active and published to Online Store.', 'error');
      updateSummary(configurator, config, options);
    });

    Promise.all(options.devices.map(function(device) {
      return resolveVariant(device).catch(function() {
        device.available = false;
        return device;
      });
    })).then(function() {
      renderDeviceOptions(configurator, config, options);
      updateSummary(configurator, config, options);
    });

    resolveVariant(options.maps).then(function(maps) {
      options.maps = maps;
      if (mapsMedia && maps.image) {
        mapsMedia.classList.remove('bm3-map-media--fallback');
        mapsMedia.innerHTML = '';
        var image = document.createElement('img');
        image.src = maps.image;
        image.alt = '';
        image.loading = 'lazy';
        mapsMedia.appendChild(image);
      }
      if (mapsPrice) {
        mapsPrice.textContent = maps.available ? money(maps.price) : 'Unavailable';
      }
      if (!maps.available) {
        configurator.querySelector('[data-bm3-maps]').disabled = true;
      }
      updateSummary(configurator, config, options);
    }).catch(function() {
      if (mapsPrice) {
        mapsPrice.textContent = 'Unavailable';
      }
      configurator.querySelector('[data-bm3-maps]').disabled = true;
    });

    configurator.addEventListener('change', function() {
      updateSummary(configurator, config, options);
    });

    configurator.querySelector('[data-bm3-vin]').addEventListener('input', function(event) {
      event.target.value = event.target.value.toUpperCase();
      var wrap = event.target.closest('.bm3-vin-wrap');
      if (wrap) {
        wrap.classList.toggle('has-value', event.target.value.trim().length === 17);
      }
      updateSummary(configurator, config, options);
    });

    configurator.querySelector('[data-bm3-add]').addEventListener('click', function() {
      addToCart(configurator, config, options);
    });

    updateSummary(configurator, config, options);
  }

  function otsVariant(configurator, config) {
    var variantSelect = configurator.querySelector('[data-variants]');
    var selectedId = variantSelect ? variantId(variantSelect.value) : variantId(config.product.variantId);

    return config.variants.filter(function(variant) {
      return variantId(variant.id) === selectedId;
    })[0] || null;
  }

  function otsOwner(configurator) {
    var checked = configurator.querySelector('[data-bm3-ots-owner]:checked');
    return checked ? checked.value : '';
  }

  function otsHardwareMode(configurator) {
    var checked = configurator.querySelector('[data-bm3-ots-hardware-mode]:checked');
    return checked ? checked.value : 'existing';
  }

  function otsSelectedDevice(configurator, options) {
    if (otsOwner(configurator) === 'no' || otsHardwareMode(configurator) !== 'purchase') {
      return null;
    }

    return deviceByKey(options, selectedDevice(configurator));
  }

  function setOtsError(configurator, key, message) {
    var error = configurator.querySelector('[data-bm3-ots-error="' + key + '"]');
    if (error) {
      error.textContent = message || '';
    }
  }

  function clearOtsErrors(configurator) {
    configurator.querySelectorAll('[data-bm3-ots-error]').forEach(function(error) {
      error.textContent = '';
    });
    configurator.querySelectorAll('[aria-invalid="true"]').forEach(function(control) {
      control.removeAttribute('aria-invalid');
    });
  }

  function setOtsFlowState(configurator) {
    var blocked = otsOwner(configurator) === 'no';
    var packageMessage = configurator.querySelector('[data-bm3-ots-package-message]');
    var sections = [
      configurator.querySelector('[data-bm3-ots-section="vehicle"]'),
      configurator.querySelector('[data-bm3-ots-section="adapter"]')
    ];

    if (packageMessage) {
      packageMessage.toggleAttribute('hidden', !blocked);
    }

    sections.filter(Boolean).forEach(function(section) {
      section.classList.toggle('is-disabled', blocked);
      section.querySelectorAll('input, select, button').forEach(function(control) {
        if (blocked && !control.disabled) {
          control.dataset.bm3OtsFlowDisabled = 'true';
          control.disabled = true;
        } else if (!blocked && control.dataset.bm3OtsFlowDisabled === 'true') {
          control.disabled = false;
          delete control.dataset.bm3OtsFlowDisabled;
        }
      });
    });

    setOtsHardwareState(configurator, blocked);
  }

  function setOtsHardwareState(configurator, blocked) {
    var optionsPanel = configurator.querySelector('[data-bm3-ots-hardware-options]');
    var expanded = !blocked && otsHardwareMode(configurator) === 'purchase';

    if (optionsPanel) {
      optionsPanel.toggleAttribute('hidden', !expanded);
    }
  }

  function updateOtsSummary(configurator, config, options) {
    var variant = otsVariant(configurator, config);
    var total = variant ? Number(variant.price || 0) : 0;
    var device = otsSelectedDevice(configurator, options);

    if (device && device.key !== 'none' && deviceAvailable(device, options)) {
      total += deviceTotalPrice(device, options);
    }

    var totalElement = configurator.querySelector('[data-bm3-total]');
    var button = configurator.querySelector('[data-bm3-add]');

    if (totalElement) {
      totalElement.textContent = money(total);
    }
    if (button && !button.disabled) {
      setButtonLabel(button, button.dataset.idleLabel || 'Add to Cart');
    }
  }

  function focusOtsError(section, control) {
    if (section && typeof section.scrollIntoView === 'function') {
      section.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    if (control && typeof control.focus === 'function') {
      window.setTimeout(function() {
        control.focus();
      }, 250);
    }
  }

  function validateOts(configurator, config, options) {
    clearOtsErrors(configurator);

    var owner = otsOwner(configurator);
    var ownershipSection = configurator.querySelector('[data-bm3-ots-section="ownership"]');
    var firstOwner = configurator.querySelector('[data-bm3-ots-owner]');
    if (!owner) {
      setOtsError(configurator, 'ownership', 'Choose whether you already own an active bootmod3 licence.');
      focusOtsError(ownershipSection, firstOwner);
      return null;
    }
    if (owner !== 'yes') {
      setOtsError(configurator, 'ownership', 'A complete bootmod3 package is required before you can purchase this add-on.');
      focusOtsError(ownershipSection, firstOwner);
      return null;
    }

    var vinInput = configurator.querySelector('[data-bm3-vin]');
    var vin = vinInput ? vinInput.value.replace(/\s+/g, '').toUpperCase() : '';
    if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vin)) {
      setOtsError(configurator, 'vin', vin.length !== 17 ? 'Enter a complete 17-character VIN.' : 'VINs cannot contain I, O, Q, or special characters.');
      if (vinInput) {
        vinInput.setAttribute('aria-invalid', 'true');
      }
      focusOtsError(configurator.querySelector('[data-bm3-ots-section="vehicle"]'), vinInput);
      return null;
    }

    var variant = otsVariant(configurator, config);
    var variantSelect = configurator.querySelector('[data-variants]');
    if (!variant || !variantId(variant.id)) {
      setOtsError(configurator, 'engine', 'Choose an engine before adding this Maps Pack.');
      focusOtsError(configurator.querySelector('[data-bm3-ots-section="vehicle"]'), configurator.querySelector('[data-bm3-ots-engine] select'));
      return null;
    }
    if (!variant.available) {
      setOtsError(configurator, 'engine', 'The selected engine is currently unavailable. Choose another engine.');
      if (variantSelect) {
        variantSelect.setAttribute('aria-invalid', 'true');
      }
      focusOtsError(configurator.querySelector('[data-bm3-ots-section="vehicle"]'), configurator.querySelector('[data-bm3-ots-engine] select'));
      return null;
    }

    if (otsHardwareMode(configurator) === 'purchase') {
      var deviceControl = configurator.querySelector('[name="' + configurator.id + '-device"]:checked');
      var device = deviceByKey(options, deviceControl ? deviceControl.value : '');
      if (!deviceControl || !device || device.key === 'none') {
        setOtsError(configurator, 'adapter', 'Choose a flashing hardware option or select that you already own compatible hardware.');
        var firstDevice = configurator.querySelector('[name="' + configurator.id + '-device"]:not(:disabled)');
        if (firstDevice) {
          firstDevice.setAttribute('aria-invalid', 'true');
        }
        focusOtsError(configurator.querySelector('[data-bm3-ots-section="adapter"]'), firstDevice);
        return null;
      }
      if (!deviceAvailable(device, options)) {
        setOtsError(configurator, 'adapter', 'The selected flashing hardware is unavailable. Choose another option or use existing hardware.');
        deviceControl.setAttribute('aria-invalid', 'true');
        focusOtsError(configurator.querySelector('[data-bm3-ots-section="adapter"]'), deviceControl);
        return null;
      }
    }

    return {
      vin: vin,
      variant: variant,
      hardwareMode: otsHardwareMode(configurator)
    };
  }

  function addOtsToCart(configurator, config, options) {
    var selection = validateOts(configurator, config, options);
    var button = configurator.querySelector('[data-bm3-add]');
    if (!selection || !button || button.disabled) {
      return;
    }

    var bundleId = 'bm3-ots-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
    var items = [
      {
        id: variantId(selection.variant.id),
        quantity: 1,
        properties: {
          VIN: selection.vin,
          'Existing bootmod3 licence confirmed': 'Yes',
          'Selected engine': selection.variant.title,
          _bundle_id: bundleId,
          _bundle_parent: 'true',
          _bootmod3_ots_add_on: 'true'
        }
      }
    ];
    var device = selection.hardwareMode === 'purchase' ? deviceByKey(options, selectedDevice(configurator)) : null;

    if (device && device.key !== 'none') {
      if (!deviceAvailable(device, options) || !device.variant || !variantId(device.variant.id)) {
        setOtsError(configurator, 'adapter', 'The selected flashing hardware is unavailable. Choose another option or use existing hardware.');
        return;
      }

      [device].concat(includedDevices(device, options)).forEach(function(hardware) {
        if (hardware.variant && variantId(hardware.variant.id)) {
          items.push({
            id: variantId(hardware.variant.id),
            quantity: 1,
            properties: {
              _bundle_id: bundleId,
              _bundle_parent: 'false',
              _bootmod3_ots_hardware: 'true'
            }
          });
        }
      });
    }

    button.disabled = true;
    button.textContent = 'Adding...';
    setFeedback(configurator, '', '');

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    }).then(function(response) {
      return response.json().then(function(json) {
        if (!response.ok || json.status) {
          throw new Error(json.description || json.message || 'Could not add package to cart.');
        }
        if (json.items && json.items.length !== items.length) {
          throw new Error('The complete selection was not added. Please try again.');
        }
        return json;
      });
    }).then(function() {
      setFeedback(configurator, 'Configured package added to cart.', 'success');
      refreshCart();
    }).catch(function(error) {
      console.error('BootMod3 OTS add-to-cart failed:', error, items);
      setFeedback(configurator, error.message || 'Could not add package to cart.', 'error');
    }).finally(function() {
      button.disabled = false;
      updateOtsSummary(configurator, config, options);
    });
  }

  function initOtsConfigurator(configurator, index) {
    if (configurator.dataset.bm3OtsInitialized === 'true') {
      return;
    }
    configurator.dataset.bm3OtsInitialized = 'true';
    configurator.id = configurator.id || 'bootmod3-ots-configurator-' + index;

    var configScript = configurator.querySelector('[data-bootmod3-ots-config]');
    var config = configScript ? JSON.parse(configScript.textContent) : null;
    if (!config || !config.product || !config.variants || !config.devices) {
      setFeedback(configurator, 'BootMod3 OTS configuration is missing for this product.', 'error');
      return;
    }

    var options = {
      devices: config.devices.map(function(device) {
        return Object.assign({}, device);
      })
    };
    var vinInput = configurator.querySelector('[data-bm3-vin]');

    bindImageDialog(configurator);
    Promise.all(options.devices.map(function(device) {
      return resolveVariant(device).catch(function() {
        device.available = false;
        return device;
      });
    })).then(function() {
      renderDeviceOptions(configurator, config, options);
      setOtsFlowState(configurator);
      updateOtsSummary(configurator, config, options);
    });

    configurator.addEventListener('change', function(event) {
      if (event.target.matches('[data-bm3-ots-owner]')) {
        setOtsError(configurator, 'ownership', '');
        setOtsFlowState(configurator);
      }
      if (event.target.matches('[data-bm3-ots-hardware-mode]')) {
        setOtsError(configurator, 'adapter', '');
        configurator.querySelectorAll('[name="' + configurator.id + '-device"][aria-invalid="true"]').forEach(function(control) {
          control.removeAttribute('aria-invalid');
        });
        setOtsHardwareState(configurator, otsOwner(configurator) === 'no');
      }
      if (event.target.matches('[data-bm3-ots-engine] select, [data-variants]')) {
        setOtsError(configurator, 'engine', '');
      }
      if (event.target.name === configurator.id + '-device') {
        setOtsError(configurator, 'adapter', '');
        event.target.removeAttribute('aria-invalid');
      }
      updateOtsSummary(configurator, config, options);
    });

    if (vinInput) {
      vinInput.addEventListener('input', function(event) {
        event.target.value = event.target.value.replace(/\s+/g, '').toUpperCase().slice(0, 17);
        var valid = /^[A-HJ-NPR-Z0-9]{17}$/.test(event.target.value);
        event.target.closest('.bm3-vin-wrap').classList.toggle('has-value', valid);
        if (valid) {
          setOtsError(configurator, 'vin', '');
          event.target.removeAttribute('aria-invalid');
        }
      });
    }

    window.addEventListener('product-variant-switch', function(event) {
      var switchedVariant = event.detail && event.detail.variant;
      if (!switchedVariant) {
        return;
      }
      var belongsToOtsProduct = config.variants.some(function(productVariant) {
        return variantId(productVariant.id) === variantId(switchedVariant.id);
      });
      if (belongsToOtsProduct) {
        config.product.variantId = variantId(switchedVariant.id);
        updateOtsSummary(configurator, config, options);
      }
    });

    configurator.querySelector('[data-bm3-add]').addEventListener('click', function() {
      addOtsToCart(configurator, config, options);
    });

    setOtsFlowState(configurator);
    updateOtsSummary(configurator, config, options);
  }

  function initBootmod3(root) {
    root.querySelectorAll('[data-bootmod3-configurator]').forEach(initConfigurator);
    root.querySelectorAll('[data-bootmod3-ots-configurator]').forEach(initOtsConfigurator);
  }

  document.addEventListener('DOMContentLoaded', function() {
    initBootmod3(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initBootmod3(event.target);
  });
})();
